import React from "react";
import ReservationForm from "../../../../forms/Reservation";
import styles from "./styles.module.css";

export default React.memo((props) => {
  return (
    <div className={styles.container}>
      <ReservationForm className={styles.form} />
    </div>
  );
});
